import { render, staticRenderFns } from "./CustomerDefaulter.vue?vue&type=template&id=6e5b7aa4"
import script from "./CustomerDefaulter.vue?vue&type=script&lang=js"
export * from "./CustomerDefaulter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports